var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 3.587a.48.48 0 00.478-.478v-.24A.48.48 0 0011 2.392a.48.48 0 00-.478.479v.239a.48.48 0 00.478.478zM11 18.413a.48.48 0 00-.478.478v.24a.48.48 0 00.478.478.48.48 0 00.478-.479v-.239a.48.48 0 00-.478-.478zM3.109 10.522h-.24a.48.48 0 00-.478.478.48.48 0 00.479.478h.239A.48.48 0 003.587 11a.48.48 0 00-.478-.478zM19.13 10.522h-.239a.48.48 0 00-.478.478.48.48 0 00.478.478h.24a.48.48 0 00.478-.478.48.48 0 00-.479-.478zM5.596 4.926a.462.462 0 00-.67 0 .462.462 0 000 .67l.167.167a.472.472 0 00.335.144c.12 0 .24-.048.335-.144a.462.462 0 000-.67l-.167-.167zM5.093 16.237l-.167.167a.462.462 0 000 .67.472.472 0 00.335.143c.12 0 .239-.047.335-.143l.167-.167a.462.462 0 000-.67.462.462 0 00-.67 0zM16.404 4.926l-.167.167a.462.462 0 000 .67.472.472 0 00.335.144c.12 0 .239-.048.335-.144l.167-.167a.462.462 0 000-.67.462.462 0 00-.67 0zM11.478 10.809V6.457A.48.48 0 0011 5.978a.48.48 0 00-.478.479V11c0 .12.048.24.143.335l4.736 4.758c.12 0 .597.096.692 0a.514.514 0 000-.712l-4.615-4.572z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 0C4.926 0 0 4.926 0 11s4.926 11 11 11 11-4.926 11-11S17.074 0 11 0zm0 21.043A10.042 10.042 0 01.957 11 10.042 10.042 0 0111 .957 10.042 10.042 0 0121.043 11 10.042 10.042 0 0111 21.043z",
    fill: "#484848"
  }))));
}

export default SvgClock;